import React, { useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './AudioPlayer.css';
import { MdClose } from "react-icons/md";
import { Button, Col, Row } from 'react-bootstrap';
import './LearningLounge.scss';
import { trackEvent } from '../../utils/gaTracking';
import { useSelector } from 'react-redux';

const AudioPlayerComponent = ({ playlist, setShow, withQueue = true }) => {
    const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
    const authState = useSelector((state) => state.authUser);
    const user_id = authState?.profile?.user_id;
    const user_email = authState?.profile?.email;
    
    const handleClickNext = () => {
        setCurrentTrackIndex((currentTrackIndex + 1) % playlist.length);
    };

    const handleClickPrevious = () => {
        setCurrentTrackIndex((currentTrackIndex - 1 + playlist.length) % playlist.length);
    };

    return (
        <div>
            <div className="d-flex justify-content-end">
                <Button className="btn btn-sm btn-primary float-right" onClick={() => { setShow(false) }}><MdClose /></Button>
            </div>
            <Row>
                <Col md={withQueue ? 9 : 12} className='mt-2'>
                    <div>
                        <AudioPlayer
                            src={ withQueue? playlist[currentTrackIndex]?.media_url : playlist[currentTrackIndex]?.mediaurl }
                            header={ withQueue ? `Now playing: ${playlist[currentTrackIndex]?.title}` : '' }
                            onClickNext={()=> {
                                trackEvent("hrd_knowledge_bytes_audio_skip_to_next", "HRD Audio Player", playlist[currentTrackIndex]?.title || "Unknown Track", 1, user_id, user_email);
                                handleClickNext();
                            }}
                            onClickPrevious={()=> {
                                trackEvent("hrd_knowledge_bytes_audio_skip_to_previous", "HRD Audio Player", playlist[currentTrackIndex]?.title || "Unknown Track", 1, user_id, user_email);
                                handleClickPrevious();
                            }}
                            onEnded={()=> {
                                trackEvent("hrd_knowledge_bytes_audio_track_completed", "HRD Audio Player", playlist[currentTrackIndex]?.title || "Unknown Track", 1, user_id, user_email);
                                handleClickNext();
                            }}
                            showSkipControls
                            isPlaying={false}
                        />
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        </div>

                    </div>
                </Col>
                {withQueue && <Col md={3}>
                    <div className='d-flex justify-content-between mt-2' style={{ backgroundColor: '#000', color: '#fff', borderRadius: '5px 5px 0px 0px' }}>
                        <div className='p-3 text-center'>Queue</div>
                    </div>
                    <ul className="playlist" style={{ overflow: 'scroll', height: '300px' }}>
                        {playlist.map((track, index) => (
                            <li
                                key={index}
                                onClick={() => {
                                    trackEvent("hrd_knowledge_bytes_new_audio_track_opened", "HRD Audio Player", playlist[index]?.title || "Unknown Track", 1, user_id, user_email);
                                    setCurrentTrackIndex(index);
                                    }
                                }
                                className={currentTrackIndex === index ? 'active' : ''}
                            >
                                {track.title}
                            </li>
                        ))}
                    </ul>
                </Col>}
            </Row>
        </div>
    );
};

export default AudioPlayerComponent;
